/**
 * Domain helpers for UnifiedParsingModal
 *
 * Provides domain-related aliases поверх существующих хелперов в `./urlUtils`.
 *
 * NOTE: `normalizeUrl` уже определён в `./urlUtils` и реэкспортируется
 * через barrel `./index.ts`. Импортируйте его оттуда:
 *   import { normalizeUrl } from '../utils'
 *
 * TODO (Фаза 2): извлечь общий `updateDomainsWithResults` для AI polling.
 * Сейчас в `useParsingWorkflow.ts` есть две версии (handleAnalyze ~939
 * и resumeAnalysisPoll ~1444) с РАЗНОЙ логикой:
 *   - handleAnalyze: использует Map<url, index> (O(1)), не работает с
 *     parsed_url_id/source_id, читает recommendation из result.analysis.*
 *   - resumeAnalysisPoll: ищет сначала по parsed_url_id/source_id,
 *     обновляет эти id в domains, не использует result.analysis.*
 * Извлекать сейчас — менять поведение, делаем позже отдельной задачей.
 */

import { isPureDomain } from './urlUtils'

/**
 * Alias for isPureDomain — historically called `checkIsPureDomain` inside
 * useParsingWorkflow. Логика идентична: домен без пути считается чистым.
 */
export const checkIsPureDomain = (fullUrl?: string): boolean => isPureDomain(fullUrl)
